import Radio from './src/radio';

export default Radio;



// WEBPACK FOOTER //
// ./packages/radio/index.js